import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAdminAuth } from "@/hooks/useAdminAuth";

/**
 * Landing route for the magic link. The admin Supabase client has
 * `detectSessionInUrl: true`, so it picks up the access token from the URL
 * fragment automatically. We just wait for the auth state to resolve and
 * then route the user.
 */
const AdminAuthCallback = () => {
  const { loading, user, isAdmin } = useAdminAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (loading) return;
    if (!user) {
      navigate("/admin/login", { replace: true });
      return;
    }
    if (isAdmin) {
      navigate("/admin", { replace: true });
    } else {
      // AdminLayout will render the "no access"-screen for non-admins.
      navigate("/admin", { replace: true });
    }
  }, [loading, user, isAdmin, navigate]);

  return (
    <div className="flex min-h-screen items-center justify-center text-muted-foreground">
      Logger inn …
    </div>
  );
};

export default AdminAuthCallback;
